// Action creators
import { readJson } from './apiResponse';

// http://localhost:60452/api/OnCallSchedule/UpsertCurrentSchedule
// http://localhost:60452/api/OnCallSchedule/List
// http://localhost:60452/api/OnCallSchedule/GetMostRecentSchedule 
// http://localhost:60452/api/OnCallSchedule/GetAllRecentSchedules

var getScheduleFetch = () => {
  return function (dispatch) {
    const token = localStorage.token;
    if (!token) {
      return Promise.resolve();
    }

    return fetch('api/OnCallSchedule/GetAllRecentSchedules', {
      method: "GET",
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(results => readJson(results, 'api/OnCallSchedule/GetAllRecentSchedules'))
      .then(json => {
        if (!json) {
          return;
        }
        dispatch({ type: 'LOAD_SCHEDULE', payload: json });
      })
      .catch(err => console.error('getScheduleFetch failed:', err));
  };
}

var toggleUser = (userId, company) => {
  return function (dispatch) {
    dispatch({ type: "TOGGLE_EMAIL_LIST_USER", payload: { 'userId': userId, 'company': company } });
  };
}


// what data needs to be posted? {id: "", scheduleId: "", beginTime: "", endTime: "", prime: "", secondary: "", tertiary: ""}

var updateSchedule = (company, schedule) => {
  return function (dispatch) {
    const token = localStorage.token;
    if (!token) {
      return Promise.resolve();
    }

    return fetch("api/OnCallSchedule/UpsertCurrentSchedule", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ 'Company': company, 'LineItems': schedule['onCallLineItems']})
    })
  }
}

var sendEmail = (company, schedule) => {
  return function (dispatch) {
    var l = [];
    for (var i = 0; i < schedule['checkedUserIds'].length; i++) {
      var onCallLineItem = schedule['checkedUserIds'][i];
      l.push({ 'EmailRecipient': onCallLineItem });
    }
    const token = localStorage.token;
    if (!token) {
      return Promise.resolve();
    }

    return fetch("api/OnCallEmailList/SendEmail", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ 'Company': company, 'LineItems': l, 'ScheduleId': schedule.id })
    })
  }
}

export default { 'LOAD_SCHEDULE': getScheduleFetch, 'SEND_EMAIL': sendEmail, 'TOGGLE_USER': toggleUser, 'UPDATE_SCHEDULE': updateSchedule };


// WEBPACK FOOTER //
// ./src/actions/schedule_actions.js